import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useAddProjectsToScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	viewDefId?: string | Ref<string> | (() => string), 
	kanbanStatusId?: number | null | Ref<number | null> | (() => number | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _viewDefId = isRef<string>(viewDefId) ? viewDefId : ref<string>((typeof viewDefId === 'function') ? viewDefId() : viewDefId)
	const _kanbanStatusId = isRef<number | null>(kanbanStatusId) ? kanbanStatusId : ref<number | null>((typeof kanbanStatusId === 'function') ? kanbanStatusId() : kanbanStatusId)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		viewDefId: _viewDefId,
		kanbanStatusId: _kanbanStatusId,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof viewDefId === 'function') { _viewDefId.value = viewDefId() }
			if (typeof kanbanStatusId === 'function') { _kanbanStatusId.value = kanbanStatusId() }

			return new c.AddProjectsToScenarioCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _viewDefId.value, _kanbanStatusId.value)
		})
	}

	return {
		...result,
		authorizedAddProjectsToScenarioCommandV1: result.authorized,
		addProjectsToScenarioCommandV1: result.command,
		completedAddProjectsToScenarioCommandV1: result.completed,
		errorAddProjectsToScenarioCommandV1: result.error,
		invokeAddProjectsToScenarioCommandV1: result.invoke,
		invokingAddProjectsToScenarioCommandV1: result.invoking,
		succeedAddProjectsToScenarioCommandV1: result.succeed,
		validationErrorsAddProjectsToScenarioCommandV1: result.validationErrors,
		onSucceedAddProjectsToScenarioCommandV1: result.onSucceed,
	}
}

export function useApproveScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.ApproveScenarioCommandV1(_workspaceId.value, _portfolioId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedApproveScenarioCommandV1: result.authorized,
		approveScenarioCommandV1: result.command,
		completedApproveScenarioCommandV1: result.completed,
		errorApproveScenarioCommandV1: result.error,
		invokeApproveScenarioCommandV1: result.invoke,
		invokingApproveScenarioCommandV1: result.invoking,
		succeedApproveScenarioCommandV1: result.succeed,
		validationErrorsApproveScenarioCommandV1: result.validationErrors,
		onSucceedApproveScenarioCommandV1: result.onSucceed,
	}
}

export function useApproveScenarioProjectCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectId: _projectId,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }

			return new c.ApproveScenarioProjectCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectId.value)
		})
	}

	return {
		...result,
		authorizedApproveScenarioProjectCommandV1: result.authorized,
		approveScenarioProjectCommandV1: result.command,
		completedApproveScenarioProjectCommandV1: result.completed,
		errorApproveScenarioProjectCommandV1: result.error,
		invokeApproveScenarioProjectCommandV1: result.invoke,
		invokingApproveScenarioProjectCommandV1: result.invoking,
		succeedApproveScenarioProjectCommandV1: result.succeed,
		validationErrorsApproveScenarioProjectCommandV1: result.validationErrors,
		onSucceedApproveScenarioProjectCommandV1: result.onSucceed,
	}
}

export function useClonePortfolioScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	sourceId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	cloneName?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _sourceId = isRef<string>(sourceId) ? sourceId : ref<string>((typeof sourceId === 'function') ? sourceId() : sourceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _cloneName = isRef<string>(cloneName) ? cloneName : ref<string>((typeof cloneName === 'function') ? cloneName() : cloneName)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		sourceId: _sourceId,
		id: _id,
		cloneName: _cloneName,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof sourceId === 'function') { _sourceId.value = sourceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof cloneName === 'function') { _cloneName.value = cloneName() }

			return new c.ClonePortfolioScenarioCommandV1(_workspaceId.value, _portfolioId.value, _sourceId.value, _id.value, _cloneName.value)
		})
	}

	return {
		...result,
		authorizedClonePortfolioScenarioCommandV1: result.authorized,
		clonePortfolioScenarioCommandV1: result.command,
		completedClonePortfolioScenarioCommandV1: result.completed,
		errorClonePortfolioScenarioCommandV1: result.error,
		invokeClonePortfolioScenarioCommandV1: result.invoke,
		invokingClonePortfolioScenarioCommandV1: result.invoking,
		succeedClonePortfolioScenarioCommandV1: result.succeed,
		validationErrorsClonePortfolioScenarioCommandV1: result.validationErrors,
		onSucceedClonePortfolioScenarioCommandV1: result.onSucceed,
	}
}

export function useConnectToCorporateScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	corporateScenarioId?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _corporateScenarioId = isRef<string>(corporateScenarioId) ? corporateScenarioId : ref<string>((typeof corporateScenarioId === 'function') ? corporateScenarioId() : corporateScenarioId)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		corporateScenarioId: _corporateScenarioId,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof corporateScenarioId === 'function') { _corporateScenarioId.value = corporateScenarioId() }

			return new c.ConnectToCorporateScenarioCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _corporateScenarioId.value)
		})
	}

	return {
		...result,
		authorizedConnectToCorporateScenarioCommandV1: result.authorized,
		connectToCorporateScenarioCommandV1: result.command,
		completedConnectToCorporateScenarioCommandV1: result.completed,
		errorConnectToCorporateScenarioCommandV1: result.error,
		invokeConnectToCorporateScenarioCommandV1: result.invoke,
		invokingConnectToCorporateScenarioCommandV1: result.invoking,
		succeedConnectToCorporateScenarioCommandV1: result.succeed,
		validationErrorsConnectToCorporateScenarioCommandV1: result.validationErrors,
		onSucceedConnectToCorporateScenarioCommandV1: result.onSucceed,
	}
}

export function useCreatePortfolioScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	corporateScenarioId?: string | Ref<string> | (() => string), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	criteriaHierarchyId?: number | null | Ref<number | null> | (() => number | null), 
	weightsSetId?: number | null | Ref<number | null> | (() => number | null), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
	denomination?: any | Ref<any> | (() => any), 
	approvalAcceptedStatusId?: number | null | Ref<number | null> | (() => number | null), 
	approvalRejectedStatusId?: number | null | Ref<number | null> | (() => number | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _corporateScenarioId = isRef<string>(corporateScenarioId) ? corporateScenarioId : ref<string>((typeof corporateScenarioId === 'function') ? corporateScenarioId() : corporateScenarioId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _criteriaHierarchyId = isRef<number | null>(criteriaHierarchyId) ? criteriaHierarchyId : ref<number | null>((typeof criteriaHierarchyId === 'function') ? criteriaHierarchyId() : criteriaHierarchyId)
	const _weightsSetId = isRef<number | null>(weightsSetId) ? weightsSetId : ref<number | null>((typeof weightsSetId === 'function') ? weightsSetId() : weightsSetId)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _approvalAcceptedStatusId = isRef<number | null>(approvalAcceptedStatusId) ? approvalAcceptedStatusId : ref<number | null>((typeof approvalAcceptedStatusId === 'function') ? approvalAcceptedStatusId() : approvalAcceptedStatusId)
	const _approvalRejectedStatusId = isRef<number | null>(approvalRejectedStatusId) ? approvalRejectedStatusId : ref<number | null>((typeof approvalRejectedStatusId === 'function') ? approvalRejectedStatusId() : approvalRejectedStatusId)

	const result = {
		workspaceId: _workspaceId,
		corporateScenarioId: _corporateScenarioId,
		portfolioId: _portfolioId,
		id: _id,
		name: _name,
		description: _description,
		criteriaHierarchyId: _criteriaHierarchyId,
		weightsSetId: _weightsSetId,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,
		denomination: _denomination,
		approvalAcceptedStatusId: _approvalAcceptedStatusId,
		approvalRejectedStatusId: _approvalRejectedStatusId,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof corporateScenarioId === 'function') { _corporateScenarioId.value = corporateScenarioId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof criteriaHierarchyId === 'function') { _criteriaHierarchyId.value = criteriaHierarchyId() }
			if (typeof weightsSetId === 'function') { _weightsSetId.value = weightsSetId() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof approvalAcceptedStatusId === 'function') { _approvalAcceptedStatusId.value = approvalAcceptedStatusId() }
			if (typeof approvalRejectedStatusId === 'function') { _approvalRejectedStatusId.value = approvalRejectedStatusId() }

			return new c.CreatePortfolioScenarioCommandV1(_workspaceId.value, _corporateScenarioId.value, _portfolioId.value, _id.value, _name.value, _description.value, _criteriaHierarchyId.value, _weightsSetId.value, _applyBenefitsConfidenceFactor.value, _denomination.value, _approvalAcceptedStatusId.value, _approvalRejectedStatusId.value)
		})
	}

	return {
		...result,
		authorizedCreatePortfolioScenarioCommandV1: result.authorized,
		createPortfolioScenarioCommandV1: result.command,
		completedCreatePortfolioScenarioCommandV1: result.completed,
		errorCreatePortfolioScenarioCommandV1: result.error,
		invokeCreatePortfolioScenarioCommandV1: result.invoke,
		invokingCreatePortfolioScenarioCommandV1: result.invoking,
		succeedCreatePortfolioScenarioCommandV1: result.succeed,
		validationErrorsCreatePortfolioScenarioCommandV1: result.validationErrors,
		onSucceedCreatePortfolioScenarioCommandV1: result.onSucceed,
	}
}

export function useDeletePortfolioScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeletePortfolioScenarioCommandV1(_workspaceId.value, _portfolioId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeletePortfolioScenarioCommandV1: result.authorized,
		deletePortfolioScenarioCommandV1: result.command,
		completedDeletePortfolioScenarioCommandV1: result.completed,
		errorDeletePortfolioScenarioCommandV1: result.error,
		invokeDeletePortfolioScenarioCommandV1: result.invoke,
		invokingDeletePortfolioScenarioCommandV1: result.invoking,
		succeedDeletePortfolioScenarioCommandV1: result.succeed,
		validationErrorsDeletePortfolioScenarioCommandV1: result.validationErrors,
		onSucceedDeletePortfolioScenarioCommandV1: result.onSucceed,
	}
}

export function useLockProjectScenarioAcceptanceCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectIds?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectIds = isRef<any>(projectIds) ? projectIds : ref<any>((typeof projectIds === 'function') ? projectIds() : projectIds)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectIds: _projectIds,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectIds === 'function') { _projectIds.value = projectIds() }

			return new c.LockProjectScenarioAcceptanceCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectIds.value)
		})
	}

	return {
		...result,
		authorizedLockProjectScenarioAcceptanceCommandV1: result.authorized,
		lockProjectScenarioAcceptanceCommandV1: result.command,
		completedLockProjectScenarioAcceptanceCommandV1: result.completed,
		errorLockProjectScenarioAcceptanceCommandV1: result.error,
		invokeLockProjectScenarioAcceptanceCommandV1: result.invoke,
		invokingLockProjectScenarioAcceptanceCommandV1: result.invoking,
		succeedLockProjectScenarioAcceptanceCommandV1: result.succeed,
		validationErrorsLockProjectScenarioAcceptanceCommandV1: result.validationErrors,
		onSucceedLockProjectScenarioAcceptanceCommandV1: result.onSucceed,
	}
}

export function useLockProjectScenarioCommitmentDateCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectIds?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectIds = isRef<any>(projectIds) ? projectIds : ref<any>((typeof projectIds === 'function') ? projectIds() : projectIds)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectIds: _projectIds,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectIds === 'function') { _projectIds.value = projectIds() }

			return new c.LockProjectScenarioCommitmentDateCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectIds.value)
		})
	}

	return {
		...result,
		authorizedLockProjectScenarioCommitmentDateCommandV1: result.authorized,
		lockProjectScenarioCommitmentDateCommandV1: result.command,
		completedLockProjectScenarioCommitmentDateCommandV1: result.completed,
		errorLockProjectScenarioCommitmentDateCommandV1: result.error,
		invokeLockProjectScenarioCommitmentDateCommandV1: result.invoke,
		invokingLockProjectScenarioCommitmentDateCommandV1: result.invoking,
		succeedLockProjectScenarioCommitmentDateCommandV1: result.succeed,
		validationErrorsLockProjectScenarioCommitmentDateCommandV1: result.validationErrors,
		onSucceedLockProjectScenarioCommitmentDateCommandV1: result.onSucceed,
	}
}

export function useLockProjectScenarioStartDateCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectIds?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectIds = isRef<any>(projectIds) ? projectIds : ref<any>((typeof projectIds === 'function') ? projectIds() : projectIds)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectIds: _projectIds,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectIds === 'function') { _projectIds.value = projectIds() }

			return new c.LockProjectScenarioStartDateCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectIds.value)
		})
	}

	return {
		...result,
		authorizedLockProjectScenarioStartDateCommandV1: result.authorized,
		lockProjectScenarioStartDateCommandV1: result.command,
		completedLockProjectScenarioStartDateCommandV1: result.completed,
		errorLockProjectScenarioStartDateCommandV1: result.error,
		invokeLockProjectScenarioStartDateCommandV1: result.invoke,
		invokingLockProjectScenarioStartDateCommandV1: result.invoking,
		succeedLockProjectScenarioStartDateCommandV1: result.succeed,
		validationErrorsLockProjectScenarioStartDateCommandV1: result.validationErrors,
		onSucceedLockProjectScenarioStartDateCommandV1: result.onSucceed,
	}
}

export function useOptimizeSelectionCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	resources?: any | Ref<any> | (() => any), 
	totalCost?: number | null | Ref<number | null> | (() => number | null), 
	opex?: number | null | Ref<number | null> | (() => number | null), 
	capex?: number | null | Ref<number | null> | (() => number | null), 
	othex?: number | null | Ref<number | null> | (() => number | null), 
	expenses?: number | null | Ref<number | null> | (() => number | null), 
	opexExpenses?: number | null | Ref<number | null> | (() => number | null), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _resources = isRef<any>(resources) ? resources : ref<any>((typeof resources === 'function') ? resources() : resources)
	const _totalCost = isRef<number | null>(totalCost) ? totalCost : ref<number | null>((typeof totalCost === 'function') ? totalCost() : totalCost)
	const _opex = isRef<number | null>(opex) ? opex : ref<number | null>((typeof opex === 'function') ? opex() : opex)
	const _capex = isRef<number | null>(capex) ? capex : ref<number | null>((typeof capex === 'function') ? capex() : capex)
	const _othex = isRef<number | null>(othex) ? othex : ref<number | null>((typeof othex === 'function') ? othex() : othex)
	const _expenses = isRef<number | null>(expenses) ? expenses : ref<number | null>((typeof expenses === 'function') ? expenses() : expenses)
	const _opexExpenses = isRef<number | null>(opexExpenses) ? opexExpenses : ref<number | null>((typeof opexExpenses === 'function') ? opexExpenses() : opexExpenses)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		resources: _resources,
		totalCost: _totalCost,
		opex: _opex,
		capex: _capex,
		othex: _othex,
		expenses: _expenses,
		opexExpenses: _opexExpenses,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof resources === 'function') { _resources.value = resources() }
			if (typeof totalCost === 'function') { _totalCost.value = totalCost() }
			if (typeof opex === 'function') { _opex.value = opex() }
			if (typeof capex === 'function') { _capex.value = capex() }
			if (typeof othex === 'function') { _othex.value = othex() }
			if (typeof expenses === 'function') { _expenses.value = expenses() }
			if (typeof opexExpenses === 'function') { _opexExpenses.value = opexExpenses() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }

			return new c.OptimizeSelectionCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _resources.value, _totalCost.value, _opex.value, _capex.value, _othex.value, _expenses.value, _opexExpenses.value, _applyBenefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedOptimizeSelectionCommandV1: result.authorized,
		optimizeSelectionCommandV1: result.command,
		completedOptimizeSelectionCommandV1: result.completed,
		errorOptimizeSelectionCommandV1: result.error,
		invokeOptimizeSelectionCommandV1: result.invoke,
		invokingOptimizeSelectionCommandV1: result.invoking,
		succeedOptimizeSelectionCommandV1: result.succeed,
		validationErrorsOptimizeSelectionCommandV1: result.validationErrors,
		onSucceedOptimizeSelectionCommandV1: result.onSucceed,
	}
}

export function useRemoveProjectsFromScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectIds?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectIds = isRef<any>(projectIds) ? projectIds : ref<any>((typeof projectIds === 'function') ? projectIds() : projectIds)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectIds: _projectIds,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectIds === 'function') { _projectIds.value = projectIds() }

			return new c.RemoveProjectsFromScenarioCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectIds.value)
		})
	}

	return {
		...result,
		authorizedRemoveProjectsFromScenarioCommandV1: result.authorized,
		removeProjectsFromScenarioCommandV1: result.command,
		completedRemoveProjectsFromScenarioCommandV1: result.completed,
		errorRemoveProjectsFromScenarioCommandV1: result.error,
		invokeRemoveProjectsFromScenarioCommandV1: result.invoke,
		invokingRemoveProjectsFromScenarioCommandV1: result.invoking,
		succeedRemoveProjectsFromScenarioCommandV1: result.succeed,
		validationErrorsRemoveProjectsFromScenarioCommandV1: result.validationErrors,
		onSucceedRemoveProjectsFromScenarioCommandV1: result.onSucceed,
	}
}

export function useSaveReviewGridCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	grid?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _grid = isRef<string>(grid) ? grid : ref<string>((typeof grid === 'function') ? grid() : grid)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		grid: _grid,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof grid === 'function') { _grid.value = grid() }

			return new c.SaveReviewGridCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _grid.value)
		})
	}

	return {
		...result,
		authorizedSaveReviewGridCommandV1: result.authorized,
		saveReviewGridCommandV1: result.command,
		completedSaveReviewGridCommandV1: result.completed,
		errorSaveReviewGridCommandV1: result.error,
		invokeSaveReviewGridCommandV1: result.invoke,
		invokingSaveReviewGridCommandV1: result.invoking,
		succeedSaveReviewGridCommandV1: result.succeed,
		validationErrorsSaveReviewGridCommandV1: result.validationErrors,
		onSucceedSaveReviewGridCommandV1: result.onSucceed,
	}
}

export function useUnlockProjectScenarioAcceptanceCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectIds?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectIds = isRef<any>(projectIds) ? projectIds : ref<any>((typeof projectIds === 'function') ? projectIds() : projectIds)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectIds: _projectIds,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectIds === 'function') { _projectIds.value = projectIds() }

			return new c.UnlockProjectScenarioAcceptanceCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectIds.value)
		})
	}

	return {
		...result,
		authorizedUnlockProjectScenarioAcceptanceCommandV1: result.authorized,
		unlockProjectScenarioAcceptanceCommandV1: result.command,
		completedUnlockProjectScenarioAcceptanceCommandV1: result.completed,
		errorUnlockProjectScenarioAcceptanceCommandV1: result.error,
		invokeUnlockProjectScenarioAcceptanceCommandV1: result.invoke,
		invokingUnlockProjectScenarioAcceptanceCommandV1: result.invoking,
		succeedUnlockProjectScenarioAcceptanceCommandV1: result.succeed,
		validationErrorsUnlockProjectScenarioAcceptanceCommandV1: result.validationErrors,
		onSucceedUnlockProjectScenarioAcceptanceCommandV1: result.onSucceed,
	}
}

export function useUnlockProjectScenarioCommitmentDateCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectIds?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectIds = isRef<any>(projectIds) ? projectIds : ref<any>((typeof projectIds === 'function') ? projectIds() : projectIds)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectIds: _projectIds,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectIds === 'function') { _projectIds.value = projectIds() }

			return new c.UnlockProjectScenarioCommitmentDateCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectIds.value)
		})
	}

	return {
		...result,
		authorizedUnlockProjectScenarioCommitmentDateCommandV1: result.authorized,
		unlockProjectScenarioCommitmentDateCommandV1: result.command,
		completedUnlockProjectScenarioCommitmentDateCommandV1: result.completed,
		errorUnlockProjectScenarioCommitmentDateCommandV1: result.error,
		invokeUnlockProjectScenarioCommitmentDateCommandV1: result.invoke,
		invokingUnlockProjectScenarioCommitmentDateCommandV1: result.invoking,
		succeedUnlockProjectScenarioCommitmentDateCommandV1: result.succeed,
		validationErrorsUnlockProjectScenarioCommitmentDateCommandV1: result.validationErrors,
		onSucceedUnlockProjectScenarioCommitmentDateCommandV1: result.onSucceed,
	}
}

export function useUnlockProjectScenarioStartDateCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectIds?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectIds = isRef<any>(projectIds) ? projectIds : ref<any>((typeof projectIds === 'function') ? projectIds() : projectIds)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectIds: _projectIds,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectIds === 'function') { _projectIds.value = projectIds() }

			return new c.UnlockProjectScenarioStartDateCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectIds.value)
		})
	}

	return {
		...result,
		authorizedUnlockProjectScenarioStartDateCommandV1: result.authorized,
		unlockProjectScenarioStartDateCommandV1: result.command,
		completedUnlockProjectScenarioStartDateCommandV1: result.completed,
		errorUnlockProjectScenarioStartDateCommandV1: result.error,
		invokeUnlockProjectScenarioStartDateCommandV1: result.invoke,
		invokingUnlockProjectScenarioStartDateCommandV1: result.invoking,
		succeedUnlockProjectScenarioStartDateCommandV1: result.succeed,
		validationErrorsUnlockProjectScenarioStartDateCommandV1: result.validationErrors,
		onSucceedUnlockProjectScenarioStartDateCommandV1: result.onSucceed,
	}
}

export function useUpdatePortfolioScenarioCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	corporateScenarioId?: string | Ref<string> | (() => string), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	criteriaHierarchyId?: number | null | Ref<number | null> | (() => number | null), 
	weightsSetId?: number | null | Ref<number | null> | (() => number | null), 
	applyBenefitsConfidenceFactor?: boolean | Ref<boolean> | (() => boolean), 
	denomination?: any | Ref<any> | (() => any), 
	approvalAcceptedStatusId?: number | null | Ref<number | null> | (() => number | null), 
	approvalRejectedStatusId?: number | null | Ref<number | null> | (() => number | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _corporateScenarioId = isRef<string>(corporateScenarioId) ? corporateScenarioId : ref<string>((typeof corporateScenarioId === 'function') ? corporateScenarioId() : corporateScenarioId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _criteriaHierarchyId = isRef<number | null>(criteriaHierarchyId) ? criteriaHierarchyId : ref<number | null>((typeof criteriaHierarchyId === 'function') ? criteriaHierarchyId() : criteriaHierarchyId)
	const _weightsSetId = isRef<number | null>(weightsSetId) ? weightsSetId : ref<number | null>((typeof weightsSetId === 'function') ? weightsSetId() : weightsSetId)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>((typeof applyBenefitsConfidenceFactor === 'function') ? applyBenefitsConfidenceFactor() : applyBenefitsConfidenceFactor)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _approvalAcceptedStatusId = isRef<number | null>(approvalAcceptedStatusId) ? approvalAcceptedStatusId : ref<number | null>((typeof approvalAcceptedStatusId === 'function') ? approvalAcceptedStatusId() : approvalAcceptedStatusId)
	const _approvalRejectedStatusId = isRef<number | null>(approvalRejectedStatusId) ? approvalRejectedStatusId : ref<number | null>((typeof approvalRejectedStatusId === 'function') ? approvalRejectedStatusId() : approvalRejectedStatusId)

	const result = {
		workspaceId: _workspaceId,
		corporateScenarioId: _corporateScenarioId,
		portfolioId: _portfolioId,
		id: _id,
		name: _name,
		description: _description,
		criteriaHierarchyId: _criteriaHierarchyId,
		weightsSetId: _weightsSetId,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,
		denomination: _denomination,
		approvalAcceptedStatusId: _approvalAcceptedStatusId,
		approvalRejectedStatusId: _approvalRejectedStatusId,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof corporateScenarioId === 'function') { _corporateScenarioId.value = corporateScenarioId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof criteriaHierarchyId === 'function') { _criteriaHierarchyId.value = criteriaHierarchyId() }
			if (typeof weightsSetId === 'function') { _weightsSetId.value = weightsSetId() }
			if (typeof applyBenefitsConfidenceFactor === 'function') { _applyBenefitsConfidenceFactor.value = applyBenefitsConfidenceFactor() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof approvalAcceptedStatusId === 'function') { _approvalAcceptedStatusId.value = approvalAcceptedStatusId() }
			if (typeof approvalRejectedStatusId === 'function') { _approvalRejectedStatusId.value = approvalRejectedStatusId() }

			return new c.UpdatePortfolioScenarioCommandV1(_workspaceId.value, _corporateScenarioId.value, _portfolioId.value, _id.value, _name.value, _description.value, _criteriaHierarchyId.value, _weightsSetId.value, _applyBenefitsConfidenceFactor.value, _denomination.value, _approvalAcceptedStatusId.value, _approvalRejectedStatusId.value)
		})
	}

	return {
		...result,
		authorizedUpdatePortfolioScenarioCommandV1: result.authorized,
		updatePortfolioScenarioCommandV1: result.command,
		completedUpdatePortfolioScenarioCommandV1: result.completed,
		errorUpdatePortfolioScenarioCommandV1: result.error,
		invokeUpdatePortfolioScenarioCommandV1: result.invoke,
		invokingUpdatePortfolioScenarioCommandV1: result.invoking,
		succeedUpdatePortfolioScenarioCommandV1: result.succeed,
		validationErrorsUpdatePortfolioScenarioCommandV1: result.validationErrors,
		onSucceedUpdatePortfolioScenarioCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectScenarioAcceptanceCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectIds?: any | Ref<any> | (() => any), 
	acceptance?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectIds = isRef<any>(projectIds) ? projectIds : ref<any>((typeof projectIds === 'function') ? projectIds() : projectIds)
	const _acceptance = isRef<any>(acceptance) ? acceptance : ref<any>((typeof acceptance === 'function') ? acceptance() : acceptance)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectIds: _projectIds,
		acceptance: _acceptance,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectIds === 'function') { _projectIds.value = projectIds() }
			if (typeof acceptance === 'function') { _acceptance.value = acceptance() }

			return new c.UpdateProjectScenarioAcceptanceCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectIds.value, _acceptance.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectScenarioAcceptanceCommandV1: result.authorized,
		updateProjectScenarioAcceptanceCommandV1: result.command,
		completedUpdateProjectScenarioAcceptanceCommandV1: result.completed,
		errorUpdateProjectScenarioAcceptanceCommandV1: result.error,
		invokeUpdateProjectScenarioAcceptanceCommandV1: result.invoke,
		invokingUpdateProjectScenarioAcceptanceCommandV1: result.invoking,
		succeedUpdateProjectScenarioAcceptanceCommandV1: result.succeed,
		validationErrorsUpdateProjectScenarioAcceptanceCommandV1: result.validationErrors,
		onSucceedUpdateProjectScenarioAcceptanceCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectScenarioCommitmentDateCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectIds?: any | Ref<any> | (() => any), 
	commitmentDate?: any | null | Ref<any | null> | (() => any | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectIds = isRef<any>(projectIds) ? projectIds : ref<any>((typeof projectIds === 'function') ? projectIds() : projectIds)
	const _commitmentDate = isRef<any | null>(commitmentDate) ? commitmentDate : ref<any | null>((typeof commitmentDate === 'function') ? commitmentDate() : commitmentDate)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectIds: _projectIds,
		commitmentDate: _commitmentDate,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectIds === 'function') { _projectIds.value = projectIds() }
			if (typeof commitmentDate === 'function') { _commitmentDate.value = commitmentDate() }

			return new c.UpdateProjectScenarioCommitmentDateCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectIds.value, _commitmentDate.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectScenarioCommitmentDateCommandV1: result.authorized,
		updateProjectScenarioCommitmentDateCommandV1: result.command,
		completedUpdateProjectScenarioCommitmentDateCommandV1: result.completed,
		errorUpdateProjectScenarioCommitmentDateCommandV1: result.error,
		invokeUpdateProjectScenarioCommitmentDateCommandV1: result.invoke,
		invokingUpdateProjectScenarioCommitmentDateCommandV1: result.invoking,
		succeedUpdateProjectScenarioCommitmentDateCommandV1: result.succeed,
		validationErrorsUpdateProjectScenarioCommitmentDateCommandV1: result.validationErrors,
		onSucceedUpdateProjectScenarioCommitmentDateCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectScenarioMaxStartDateCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectIds?: any | Ref<any> | (() => any), 
	maxStartDate?: any | null | Ref<any | null> | (() => any | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectIds = isRef<any>(projectIds) ? projectIds : ref<any>((typeof projectIds === 'function') ? projectIds() : projectIds)
	const _maxStartDate = isRef<any | null>(maxStartDate) ? maxStartDate : ref<any | null>((typeof maxStartDate === 'function') ? maxStartDate() : maxStartDate)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectIds: _projectIds,
		maxStartDate: _maxStartDate,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectIds === 'function') { _projectIds.value = projectIds() }
			if (typeof maxStartDate === 'function') { _maxStartDate.value = maxStartDate() }

			return new c.UpdateProjectScenarioMaxStartDateCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectIds.value, _maxStartDate.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectScenarioMaxStartDateCommandV1: result.authorized,
		updateProjectScenarioMaxStartDateCommandV1: result.command,
		completedUpdateProjectScenarioMaxStartDateCommandV1: result.completed,
		errorUpdateProjectScenarioMaxStartDateCommandV1: result.error,
		invokeUpdateProjectScenarioMaxStartDateCommandV1: result.invoke,
		invokingUpdateProjectScenarioMaxStartDateCommandV1: result.invoking,
		succeedUpdateProjectScenarioMaxStartDateCommandV1: result.succeed,
		validationErrorsUpdateProjectScenarioMaxStartDateCommandV1: result.validationErrors,
		onSucceedUpdateProjectScenarioMaxStartDateCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectScenarioMinStartDateCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectIds?: any | Ref<any> | (() => any), 
	minStartDate?: any | null | Ref<any | null> | (() => any | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectIds = isRef<any>(projectIds) ? projectIds : ref<any>((typeof projectIds === 'function') ? projectIds() : projectIds)
	const _minStartDate = isRef<any | null>(minStartDate) ? minStartDate : ref<any | null>((typeof minStartDate === 'function') ? minStartDate() : minStartDate)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectIds: _projectIds,
		minStartDate: _minStartDate,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectIds === 'function') { _projectIds.value = projectIds() }
			if (typeof minStartDate === 'function') { _minStartDate.value = minStartDate() }

			return new c.UpdateProjectScenarioMinStartDateCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectIds.value, _minStartDate.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectScenarioMinStartDateCommandV1: result.authorized,
		updateProjectScenarioMinStartDateCommandV1: result.command,
		completedUpdateProjectScenarioMinStartDateCommandV1: result.completed,
		errorUpdateProjectScenarioMinStartDateCommandV1: result.error,
		invokeUpdateProjectScenarioMinStartDateCommandV1: result.invoke,
		invokingUpdateProjectScenarioMinStartDateCommandV1: result.invoking,
		succeedUpdateProjectScenarioMinStartDateCommandV1: result.succeed,
		validationErrorsUpdateProjectScenarioMinStartDateCommandV1: result.validationErrors,
		onSucceedUpdateProjectScenarioMinStartDateCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectScenarioPlanLockCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	lockedPlanId?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _lockedPlanId = isRef<string>(lockedPlanId) ? lockedPlanId : ref<string>((typeof lockedPlanId === 'function') ? lockedPlanId() : lockedPlanId)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectId: _projectId,
		lockedPlanId: _lockedPlanId,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof lockedPlanId === 'function') { _lockedPlanId.value = lockedPlanId() }

			return new c.UpdateProjectScenarioPlanLockCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectId.value, _lockedPlanId.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectScenarioPlanLockCommandV1: result.authorized,
		updateProjectScenarioPlanLockCommandV1: result.command,
		completedUpdateProjectScenarioPlanLockCommandV1: result.completed,
		errorUpdateProjectScenarioPlanLockCommandV1: result.error,
		invokeUpdateProjectScenarioPlanLockCommandV1: result.invoke,
		invokingUpdateProjectScenarioPlanLockCommandV1: result.invoking,
		succeedUpdateProjectScenarioPlanLockCommandV1: result.succeed,
		validationErrorsUpdateProjectScenarioPlanLockCommandV1: result.validationErrors,
		onSucceedUpdateProjectScenarioPlanLockCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectScenarioStartDateCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectIds?: any | Ref<any> | (() => any), 
	startDate?: any | null | Ref<any | null> | (() => any | null), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectIds = isRef<any>(projectIds) ? projectIds : ref<any>((typeof projectIds === 'function') ? projectIds() : projectIds)
	const _startDate = isRef<any | null>(startDate) ? startDate : ref<any | null>((typeof startDate === 'function') ? startDate() : startDate)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectIds: _projectIds,
		startDate: _startDate,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectIds === 'function') { _projectIds.value = projectIds() }
			if (typeof startDate === 'function') { _startDate.value = startDate() }

			return new c.UpdateProjectScenarioStartDateCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _projectIds.value, _startDate.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectScenarioStartDateCommandV1: result.authorized,
		updateProjectScenarioStartDateCommandV1: result.command,
		completedUpdateProjectScenarioStartDateCommandV1: result.completed,
		errorUpdateProjectScenarioStartDateCommandV1: result.error,
		invokeUpdateProjectScenarioStartDateCommandV1: result.invoke,
		invokingUpdateProjectScenarioStartDateCommandV1: result.invoking,
		succeedUpdateProjectScenarioStartDateCommandV1: result.succeed,
		validationErrorsUpdateProjectScenarioStartDateCommandV1: result.validationErrors,
		onSucceedUpdateProjectScenarioStartDateCommandV1: result.onSucceed,
	}
}

export function useUpdateScenarioAcceptancesCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	acceptances?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _acceptances = isRef<any>(acceptances) ? acceptances : ref<any>((typeof acceptances === 'function') ? acceptances() : acceptances)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		acceptances: _acceptances,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof acceptances === 'function') { _acceptances.value = acceptances() }

			return new c.UpdateScenarioAcceptancesCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _acceptances.value)
		})
	}

	return {
		...result,
		authorizedUpdateScenarioAcceptancesCommandV1: result.authorized,
		updateScenarioAcceptancesCommandV1: result.command,
		completedUpdateScenarioAcceptancesCommandV1: result.completed,
		errorUpdateScenarioAcceptancesCommandV1: result.error,
		invokeUpdateScenarioAcceptancesCommandV1: result.invoke,
		invokingUpdateScenarioAcceptancesCommandV1: result.invoking,
		succeedUpdateScenarioAcceptancesCommandV1: result.succeed,
		validationErrorsUpdateScenarioAcceptancesCommandV1: result.validationErrors,
		onSucceedUpdateScenarioAcceptancesCommandV1: result.onSucceed,
	}
}

